import { UiTypography } from '@/components/ui/Typography';

import { onboardingPaywallSectionTimerTime } from '../Timer/constants';

import MainImg from './assets/main.png';
import {
  SectionImagesArrowDownStyles,
  SectionImagesImageContainerStyles,
  SectionImagesStyles,
  SectionImagesTimerStyles,
  SectionImagesTitleStyles,
} from './Images.styles';

export const SectionImages: React.FC = () => {
  return (
    <SectionImagesStyles>
      <SectionImagesTitleStyles color="black">
        Welcome to your{' '}
        <UiTypography variant="inherit" color="gradient" component="span">
          AI-Universe
        </UiTypography>
      </SectionImagesTitleStyles>
      <UiTypography
        variant="body-large"
        className="images-subtitle"
        color="black"
      >
        Your private non-judgemental space
      </UiTypography>
      <SectionImagesImageContainerStyles>
        <img src={MainImg} alt="AI" />

        <SectionImagesArrowDownStyles>
          <img
            src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/paywall/arrow-down.png"
            alt="Arrow down"
          />
        </SectionImagesArrowDownStyles>
        <SectionImagesTimerStyles
          timeToExpire={onboardingPaywallSectionTimerTime * 1000 * 60}
        />
      </SectionImagesImageContainerStyles>
    </SectionImagesStyles>
  );
};
